import {default as classnames} from "classnames";

import {TooltipIconRA} from "@/components/overlay/TooltipIconRA.tsx";
import {getPercentageClass} from "@/lib/cssUtils.ts";
import {percentage} from "@/lib/format.tsx";
import {UptimeTotals} from "@/lib/queries/reports.ts";
import {SLAMetricBlock} from "@/pages/reports/sla/details/SLAMetricBlock.tsx";

export const SLAReportOverviewStats = ({
  num_services,
  num_services_included_in_global_uptime,
  uptime_sla: averageTargetSLA,
  uptime_pct: averageUptime,
  outages,
}: UptimeTotals) => {
  const excludedChecks = num_services - num_services_included_in_global_uptime;
  const percentageGrade = getPercentageClass(averageUptime, averageTargetSLA);
  return (
    <div className="row gx-4 mb-4">
      <div className="col">
        <SLAMetricBlock className="p-3 text-center rounded-3" title="Checks">
          <div className={""}>
            {excludedChecks > 0 && (
              <span className="fs-5">
                <b>{num_services_included_in_global_uptime}</b> /&nbsp;
              </span>
            )}
            <span className="fs-5">{num_services} </span>
            {excludedChecks > 0 && (
              <TooltipIconRA
                iconProps={{
                  display: "inline",
                  removeDivDimensions: true,
                  className: "align-baseline",
                }}
                title={`${excludedChecks} Checks are excluded from the global uptime downtime calculations and averages, either due to their Check type, pause state or manual exclusion from metrics.`}
              />
            )}
          </div>
        </SLAMetricBlock>
      </div>
      <div className="col">
        <SLAMetricBlock className="p-3 text-center rounded-3" title="Avg. Target SLA">
          <span className="fs-5 fw-semibold">{percentage(averageTargetSLA)}</span>
        </SLAMetricBlock>
      </div>
      <div className="col">
        <SLAMetricBlock className="p-3 text-center rounded-3" title="Avg. Uptime">
          <span className={classnames("fs-5 fw-semibold", percentageGrade)}>{percentage(averageUptime)}</span>
        </SLAMetricBlock>
      </div>
      <div className="col">
        <SLAMetricBlock className="p-3 text-center rounded-3" title="Outages">
          <span className="fs-5 fw-semibold">{outages}</span>
        </SLAMetricBlock>
      </div>
    </div>
  );
};
